import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ShellService } from './shell.service';

import { I18nModule } from '@app/i18n';
import { ShellComponent } from './shell.component';
import { MaterialModule } from '@app/material.module';
import { NavigationItemComponent } from '@app/@shared/navigation-item/navigation-item.component';
import { NPSLoaderComponent } from '@app/@shared/nps/nps-loader.component';
import { ExtendedRouterLinkActiveDirective } from '@app/core/directives/extended-router-link-active.directive';
@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MaterialModule,
    I18nModule,
    RouterModule,
    NPSLoaderComponent,
  ],
  declarations: [
    ShellComponent,
    NavigationItemComponent,
    ExtendedRouterLinkActiveDirective,
  ],
  providers: [ShellService],
})
export class ShellModule {}
